export const SAVE_ABANDONEDCART=`SAVE_ABANDONEDCART`;
export const SHOW_ABANDONEDCART=`SHOW_ABANDONEDCART`;
export const CLEAR_ABANDONEDCART=`CLEAR_ABANDONEDCART`;